import React from "react";
import { motion } from "framer-motion";
import { ReactComponent as Arrow } from "../../svgs/stock-arrow.svg";
import getSymbolFromCurrency from "currency-symbol-map";

const ListItem = ({ index, currentPrice, children, color, trend, volume }) => {
  return (
    <li
      className={`flex px-4 py-1 items-center text-xs font-medium ${
        index % 2 === 0 ? "bg-blue-100" : "bg-white"
      }`}
    >
      <div className="mr-4 font-bold shrink-0 w-10 h-10 flex justify-center items-center bg-blue-200 text-blue-800 rounded-full">
        {index + 1}
      </div>
      <div className="w-full">
        <div className="flex justify-between">
          {children}
          <div className="flex gap-x-2 items-center font-bold">
            <div>
              {getSymbolFromCurrency("USD")} {currentPrice}
            </div>
            {trend === "uptrend" ? (
              <Arrow className="text-[#5CD100]" />
            ) : (
              <Arrow className="rotate-180 text-[#C90202]" />
            )}
          </div>
        </div>
        <div className="relative h-2 w-full mt-2 rounded-full">
          <div
            className="absolute left-0 top-0 bottom-0 w-full rounded-full opacity-20"
            style={{ backgroundColor: color }}
          />
          <motion.div
            className="absolute left-0 top-0 bottom-0 rounded-full"
            initial={{ width: 0, backgroundColor: color }}
            animate={{ width: `${volume}%` }}
            transition={{ duration: 1 }}
          />
        </div>
      </div>
    </li>
  );
};

export default ListItem;
